import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { Router } from "@angular/router";

import { JwtResponseI } from "./jwt-response";
import { UserI } from './user';
import { variabls } from './variabls';

@Injectable({
  providedIn: 'root'
})
export class HttpAuthService {

  private headers: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
    "Authorization": localStorage.getItem('accessToken')
  });
  public urlLogin: string;
  public urlLogout: string;

  constructor(private http: HttpClient, private router: Router) { }

  public login(user: UserI): Observable<JwtResponseI> {
    return this.http.post<JwtResponseI>(variabls.url, {
      username: user.username,
      password: user.password
    }).pipe(tap(this.setSession.bind(this)));
  }

  public isLogged(): boolean {
    const getToken = localStorage.getItem('accessToken');
    return (getToken === null) ? (false) : (true);
  }

  public logout(): void {
    this.http.get(variabls.url, { headers: this.headers }).subscribe(res => {
      localStorage.removeItem('accessToken');
      localStorage.clear();
      this.router.navigateByUrl('/');
    });
  }

  private setSession(jwtResponse: JwtResponseI) {
    localStorage.setItem('accessToken', jwtResponse.token);
    localStorage.setItem('username', jwtResponse.details.username);
    const roles = jwtResponse.details.authorities.join(',');
    localStorage.setItem('roles', roles);
    this.router.navigateByUrl(`/${this.urlLogin}`);

  }

  public setUrlLogout(url: string) {
    this.urlLogout = url;
  }

  public setUrlLogin(url: string) {
    this.urlLogin = url;
  }

}
